module.exports = __webpack_public_path__ + "static/img/sjTwo.90956f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjTwo.jpg
// module id = ZTfn
// module chunks = 1